import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'text-to-binary',
  name: 'Text to Binary',
  category: 'utilities',
  description: 'Convert text string to binary data (Base64) with configurable encoding and output format',
  icon: 'FileCode',
  color: 'blue',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
};

export default definition;
